'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';

import { ErrorBlock } from '@/components/internal/ErrorBlock';
import theme from '@/theme';

import { GlobalStyles } from '@/styles/GlobalStyles';

export default function DefaultErrorFallback() {
  useEffect(() => {
    Sentry.withScope((scope) => {
      scope.setTags({
        category: 'errorFallback',
        pathToFile: 'src/components/internal/DefaultErrorFallback.tsx',
      });

      scope.setLevel('fatal');

      Sentry.captureMessage('Unhandled error. Fallback rendered.');
    });
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles theme={theme} />
      <ErrorBlock
        logo={true}
        image="/oopsImg.webp"
        text={
          <>
            something went wrong. <br />
            Please, reload the page
          </>
        }
        buttonText="Go home"
      />
    </ThemeProvider>
  );
}
